import React from 'react';

import {UnitSystem} from 'src/lib/api/series';

const UnitSystemContext = React.createContext<UnitSystem | undefined>(undefined);

export function UnitSystemProvider({
  unitSystem,
  children,
}: {
  unitSystem: UnitSystem;
  children: React.ReactNode;
}) {
  return <UnitSystemContext.Provider value={unitSystem}>{children}</UnitSystemContext.Provider>;
}

export function useUnitSystem(): UnitSystem {
  const unitSystem = React.useContext(UnitSystemContext);
  if (unitSystem === undefined) {
    throw new Error('useUnitSystem must be used within a UnitSystemProvider');
  }
  return unitSystem;
}
